/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import styled, { css } from "styled-components";
import { enqueueSnackbar } from "notistack";
import dayjs from "dayjs";

import { Grid, Stack, TextField } from "@mui/material";

// import { IconCopyLink } from "src/icons";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import AttachFileIcon from "@mui/icons-material/AttachFile";

import { findOneOrderDraft } from "src/api/saleOrder";
import { getUserInfo } from "src/api/auth";

import device from "src/styles/device";
import useDeviceSize from "src/hooks/useDeviceSize";
import { useAuth } from "src/hooks/useAuth";
import { checkNotEmpty, convertPrice } from "src/common";

import Button from "src/components/core/Button";

const Container = styled.div`
  width: 100%;
  padding: 40px 34px;
  margin-top: 75px;
  margin-bottom: 50px;

  @media ${device.tabletL} {
    margin-top: 50px;
    margin-bottom: 75px;
    padding: 40px 0;
  }
`;

const Header = styled.span`
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 600;
  display: inline-block;
  width: 100%;
  text-align: center;

  @media ${device.tabletL} {
    font-size: 1rem;
  }
`;

const Panel = styled.div`
  border-radius: 24px;
  background: var(--White, #fff);
  display: flex;
  margin-top: 24px;
  padding: 40px;
  width: 100%;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);

  @media ${device.tabletL} {
    padding: 0px 40px;
    box-shadow: unset;
  }
  @media ${device.mobileL} {
    padding: 0 24px;
  }
`;

const OrderStatus = styled.span`
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 400;
  width: 100%;
  text-align: center;
  display: inline-block;
  color: ${({ timeout }) => (timeout ? "#E13B30" : "#005FCC")};

  @media ${device.tabletL} {
    font-size: 0.875rem;
  }
`;

const Topic = styled.span`
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  color: #252525;
`;

const SubHeading = styled.span`
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  color: #252525;
  text-decoration: ${({ underline }) => underline && "underline"};
`;

const Desc = styled.span`
  font-size: ${({ note }) => (note ? "0.875rem" : "1rem")};
  font-style: normal;
  font-weight: 400;
  color: #6c6c70;
`;

const SellerName = styled.span`
  width: 100%;
  display: inline-block;
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  color: #252525;
  margin-top: 24px;

  @media ${device.tabletL} {
    margin-bottom: 8px;
  }
`;

const TextSumPrice = styled.span`
  font-size: 1.25rem;
  color: ${({ price }) => (price ? "#E13B30" : "#252525")};
  font-weight: 600;
`;

const Columns = styled.div`
  width: 100%;
  height: 50px;
  background-color: #f3f1f2;
  border-radius: 16px 16px 0 0;
  padding: 16px 24px;
`;

const Body = styled.div`
  padding: 16px 24px;
  width: 100%;
`;

const Footer = styled.div`
  width: 100%;
  background-color: #f3f1f2;
  border-radius: 0 0 16px 16px;
  padding: 16px 24px;
`;

const TextPrice = styled.span`
  font-size: 1rem;
  color: ${({ price, sumprice }) =>
    price ? "#252525" : sumprice ? "#E13B30" : "#6C6C70"};
  font-weight: ${({ bold }) => (bold ? 600 : 400)};
`;

const LineSection = styled.div`
  width: 100%;
  height: 1px;
  background-color: #d9d9d9;
  margin-bottom: 8px;

  ${({ last }) =>
    last &&
    css`
      width: 120%;
      margin: 0 -20px 8px -20px;
    `}
`;

const Note = styled.div`
  width: 100%;
  padding: 16px 24px;
  background-color: #fff;
  border-radius: 16px;
  border: 1px solid #f3f1f2;
`;

const TextColumn = styled.div`
  color: #252525;
  font-size: 0.75rem;
  font-weight: 400;
  text-align: ${({ textAlign }) => (textAlign ? textAlign : "left")};
`;

const TextRow = styled.div`
  color: ${({ secondary }) => (secondary ? "#6C6C70" : "#252525")};
  font-size: 0.875rem;
  font-weight: 400;
  text-align: ${({ textAlign }) => (textAlign ? textAlign : "left")};
`;

const TextArea = styled.textarea`
  width: 100%;
  color: #6c6c70;
  font-size: 0.875rem;
  font-weight: 400;
  text-align: ${({ textAlign }) => (textAlign ? textAlign : "left")};
  height: max-content;
  padding: 10px 0;
  font-family: "Prompt";
  border: none;
  display: inline-table;

  :hover,
  :focus,
  :active,
  :focus-visible {
    outline: none;
  }
`;

const ButtonSubmit = styled.button`
  width: 160px;
  height: 48px;
  border-radius: 16px;
  background-color: ${({ edit }) => (edit ? "#F7CECB" : "#E13B30")};
  cursor: pointer;
  color: ${({ edit }) => (edit ? "#E13B30" : "#ffffff")};
  font-size: 1rem;
  font-weight: 500;
  border: none;
  margin: 0 8px;
`;

const TextCopyLink = styled.span`
  font-size: 1rem;
  color: #252525;
  font-weight: 500;
`;

const WrapList = styled.div`
  width: 100%;

  @media ${device.tabletL} {
    padding: 0 40px;
    margin-bottom: 50px;
  }
  @media ${device.mobileL} {
    padding: 0 24px;
  }
`;

const WrapTable = styled.div`
  width: 100%;
  overflow: scroll;
  border-radius: 16px;
  margin: 16px 0;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);

  ::-webkit-scrollbar {
    display: none;
    width: 0;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }

  @media ${device.tabletL} {
    border-radius: 16px 16px 0 0;
    margin-bottom: 0;
    box-shadow: unset;
  }
`;

const ButtomSheet = styled.div`
  width: 100%;
  padding: 16px 24px;
  border-radius: 16px 16px 0 0;
  background-color: #ffffff;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 15;
  box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
`;

const WrapCopyIcon = styled.button`
  border: none;
  border-radius: 100%;
  background-color: #f3f1f2;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
`;

const SaleOrderDetail = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const { checkAllowPermission } = useAuth();

  const [order, setOrder] = useState({});
  const [deviceWidth] = useDeviceSize();
  const [user, settUser] = useState({});

  const [isShowModal, setIsShowModal] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const fetchOrder = async () => {
    const { data } = await findOneOrderDraft(orderId);
    setOrder(data);
    // setListOrders(data.seller_list_orders)
  };

  const fetchUser = async () => {
    const data = await getUserInfo();
    settUser(data);
  };

  useEffect(() => {
    fetchOrder();
    fetchUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId]);

  const copyClipboard = async () => {
    const el = document.createElement("input");
    el.value = `https://xsurface.com/order-summary/${orderId}`;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);

    enqueueSnackbar("คัดลอกลิงก์สำเร็จ", {
      variant: "success",
    });
  };

  const copyOrder = async () => {
    const { _id, ...rest } = order;
    await window.localStorage.setItem("order", JSON.stringify(rest));
    await enqueueSnackbar("คัดลอกออเดอร์", {
      variant: "success",
    });
    await navigate(`/sale-order/create`);
  };

  return (
    <Container>
      <Header>รายละเอียดออเดอร์</Header>
      <OrderStatus timeout={order.status !== "available"}>
        {order.status === "available" ? "ออเดอร์อยู่ในเวลา" : "ออเดอร์หมดเวลา"}
      </OrderStatus>

      <Panel>
        <Grid container>
          <Grid container mb={1}>
            <Topic>เซลล์ออเดอร์</Topic>
          </Grid>

          <Grid
            container
            my={1}
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item>
              <SubHeading>{order?.running_number}</SubHeading>
            </Grid>

            <Grid item>
              <WrapCopyIcon>
                <ContentCopyIcon
                  sx={{ fontSize: 15 }}
                  onClick={() => copyOrder()}
                />
              </WrapCopyIcon>
            </Grid>
          </Grid>

          {!!order?.created_by_draft && order?.created_by_draft?.length > 0 && (
            <>
              <Grid container mt={3}>
                <Topic>หมายเลขออเดอร์ลูกค้า</Topic>
              </Grid>

              {order?.created_by_draft.map(({ _id, running_number }) => (
                <Grid container my={1}>
                  <SubHeading
                    onClick={() => navigate(`/order/detail/${_id}`)}
                    underline
                  >
                    {running_number}
                  </SubHeading>
                </Grid>
              ))}
            </>
          )}

          <Grid container mt={3}>
            <Topic>ข้อมูล</Topic>
          </Grid>

          <Grid container my={1}>
            <Grid item mr={1}>
              <SubHeading>ชื่อ</SubHeading>
            </Grid>

            <Grid item>
              <Desc>{order?.customer_name || "-"}</Desc>
            </Grid>
          </Grid>

          <Grid container mb={1}>
            <Grid item mr={1}>
              <SubHeading>อีเมล</SubHeading>
            </Grid>

            <Grid item>
              <Desc>{order?.customer_email || "-"}</Desc>
            </Grid>
          </Grid>

          <Grid container mb={1}>
            <Grid item mr={1}>
              <SubHeading>เบอร์โทรศัพท์</SubHeading>
            </Grid>

            <Grid item>
              <Desc>{order?.customer_tel || "-"}</Desc>
            </Grid>
          </Grid>

          <Grid container mt={3}>
            <Topic>ที่อยู่</Topic>
          </Grid>

          <Grid container>
            <Grid item mt={1}>
              <Desc>{`ที่อยู่ ${
                order?.shipping_address?.full_address || "-"
              }`}</Desc>
            </Grid>
          </Grid>

          {order?.ref_quotation?.running_number && (
            <>
              <Grid container mt={3}>
                <Topic>เลขที่ Sale Quotation</Topic>
              </Grid>

              <Grid container>
                <Grid item mt={1}>
                  <Desc>{order?.ref_quotation?.running_number}</Desc>
                </Grid>
              </Grid>
            </>
          )}

          <Grid container mt={3}>
            <Topic>ระยะเวลาของออเดอร์</Topic>
          </Grid>

          <Grid container flexDirection="column">
            <Grid item mt={1}>
              <Desc>{`วันที่สร้าง : ${dayjs(order?.createdAt).format(
                "DD/MM/YYYY HH:mm",
              )}`}</Desc>
            </Grid>

            <Grid item mt={1}>
              <Desc>{`วันที่หมดอายุ : ${dayjs(order?.expire_date).format(
                "DD/MM/YYYY HH:mm",
              )}`}</Desc>
            </Grid>
          </Grid>

          <Grid container mt={3}>
            <Topic>รหัสเซลล์</Topic>
          </Grid>

          <Grid container>
            <Grid item mt={1}>
              <Desc>{`${order?.created_by?.user_name}`}</Desc>
            </Grid>
          </Grid>

          {!!order?.quotation_pdf && (
            <>
              <Grid container mt={3}>
                <Topic>ใบเสนอราคา (My Account)</Topic>
              </Grid>

              <Grid container mt={1} sx={{ width: "100%" }}>
                <Grid item xs={12} sm={6} md={4} mt={1}>
                  <Button
                    fullWidth
                    onClick={() => {
                      window.open(`${order?.quotation_pdf?.docUrl}`, "_blank");
                    }}
                    sx={{ mb: 1, minWidth: { xs: "250px", sm: "350px" } }}
                    variant="outlined"
                    color="secondary"
                    startIcon={<AttachFileIcon />}
                  >
                    ใบเสนอราคา
                  </Button>

                  <Desc note>{order?.quotation_pdf?.originalFileName}</Desc>
                </Grid>
              </Grid>
            </>
          )}

          {/* <Grid container mt={3}>
          <Topic>เลขที่ Sale Quotation</Topic>
        </Grid>

        <Grid container>
          <Grid item mt={1}>
            <Desc>{`ที่อยู่ ${order?.shipping_address?.full_address}`}</Desc>
          </Grid>
        </Grid>

        <Grid container mt={3}>
          <Topic>รหัสเซลล์</Topic>
        </Grid>

        <Grid container>
          <Grid item mt={1}>
            <Desc>Namfon</Desc>
          </Grid>
        </Grid> */}
        </Grid>
      </Panel>

      {order?.seller_list_orders?.length > 0 &&
        order?.seller_list_orders.map((sell_list) => (
          <WrapList>
            <Grid container key={sell_list._id} xs={12}>
              <SellerName>
                {
                  sell_list?.product_choice_orders[0]?.product_choice_order
                    ?.product?.user?.seller?.company_name
                }
              </SellerName>

              <WrapTable>
                <Grid
                  container
                  sx={{
                    minWidth: {
                      xs: "950px",
                      sm: "950px",
                      lg: "840px",
                    },
                    // md: {boxShadow: '1px 1px 4px 0px rgba(0, 0, 0, 0.10)'},
                    borderRadius: "16px",
                    overflowX: "scroll",
                  }}
                  xs={12}
                  // mt={{ sm: 0, md: 1 }}
                  // mb={{ sm: 0, md: 2 }}
                >
                  <Columns>
                    <Grid container columnSpacing={2}>
                      <Grid xs={2} item sx={{ height: "50px" }}>
                        <TextColumn>รหัส</TextColumn>
                      </Grid>

                      <Grid xs={2} item sx={{ height: "50px" }}>
                        <TextColumn>รายการ</TextColumn>
                      </Grid>

                      <Grid
                        xs={1.333}
                        item
                        textAlign="center"
                        sx={{ height: "50px" }}
                      >
                        <TextColumn textAlign="center">จำนวน</TextColumn>
                      </Grid>

                      <Grid xs={1.333} item sx={{ height: "50px" }}>
                        <TextColumn textAlign="center">ราคาต่อหน่วย</TextColumn>
                      </Grid>

                      <Grid xs={1.333} item sx={{ height: "50px" }}>
                        <TextColumn textAlign="center">หน่วย</TextColumn>
                      </Grid>

                      <Grid xs={1.333} item sx={{ height: "50px" }}>
                        <TextColumn textAlign="center">ค่าติดตั้ง</TextColumn>
                      </Grid>

                      <Grid xs={1.333} item sx={{ height: "50px" }}>
                        <TextColumn textAlign="center">ส่วนลด</TextColumn>
                      </Grid>

                      <Grid xs={1.333} item sx={{ height: "50px" }}>
                        <TextColumn textAlign="center">
                          ราคารวมทั้งหมด
                        </TextColumn>
                      </Grid>
                    </Grid>
                  </Columns>

                  <Body>
                    {sell_list?.product_choice_orders.map((choice, index) => (
                      <div key={choice?._ide}>
                        <Grid container columnSpacing={2}>
                          <Grid xs={2} item>
                            <TextRow>
                              {choice?.product_choice_order?.product?.item_code}
                            </TextRow>
                          </Grid>

                          <Grid xs={2} item>
                            <TextRow>
                              {choice?.product_choice_order?.product?.item_name}
                            </TextRow>
                          </Grid>

                          <Grid xs={1.333} item>
                            <TextRow textAlign="center">
                              {choice?.volume}
                            </TextRow>
                          </Grid>

                          <Grid xs={1.333} item>
                            <TextRow textAlign="center">
                              {convertPrice(choice?.price)}
                            </TextRow>
                          </Grid>

                          <Grid xs={1.333} item>
                            <TextRow textAlign="center">
                              {
                                choice?.product_choice_order?.group_price
                                  ?.unit_price?.unit_th
                              }
                            </TextRow>
                          </Grid>

                          <Grid xs={1.333} item>
                            <TextRow textAlign="center">
                              {convertPrice(
                                choice?.install_detail_group?.total_install,
                              ) ?? "-"}
                            </TextRow>
                          </Grid>

                          <Grid xs={1.333} item>
                            <TextRow textAlign="center">
                              {convertPrice(choice?.discount) ?? "-"}
                            </TextRow>
                          </Grid>

                          <Grid xs={1.333} item>
                            <TextRow textAlign="center">
                              {convertPrice(choice?.total)}
                            </TextRow>
                          </Grid>
                        </Grid>
                        {choice?.product_choice_order?.color && (
                          <Grid container columnSpacing={2} mt={2}>
                            <Grid xs={2} item>
                              <TextRow
                                secondary
                              >{`${choice?.product_choice_order?.color?.color_th}/${choice?.product_choice_order?.texture_type?.type_th}`}</TextRow>
                            </Grid>
                          </Grid>
                        )}
                        {choice?.product_choice_order?.size?.width && (
                          <Grid container columnSpacing={2} mt={1}>
                            <Grid xs={2} item>
                              <TextRow secondary>
                                {choice?.product_choice_order?.size
                                  ?.quantity === "size"
                                  ? `${choice?.product_choice_order?.size?.width} ${choice?.product_choice_order?.size?.unit_width?.unit_th} x ${choice?.product_choice_order?.size?.height} ${choice?.product_choice_order?.size?.unit_height?.unit_th}  x ${choice?.product_choice_order?.size?.thickness} ${choice?.product_choice_order?.size?.unit_thickness?.unit_th} `
                                  : `${choice?.product_choice_order?.size?.capacity_size} ${choice?.product_choice_order?.size?.unit_capacity?.unit_th}`}
                              </TextRow>
                            </Grid>
                          </Grid>
                        )}

                        <Grid container columnSpacing={2} mt={2}>
                          <Grid xs={12} item>
                            <TextRow secondary>{choice?.description}</TextRow>
                            {/* <TextArea>{choice?.description}</TextArea> */}
                          </Grid>
                        </Grid>

                        {sell_list?.product_choice_orders.length > 1 &&
                          index !==
                            sell_list?.product_choice_orders.length - 1 && (
                            <Grid container my={2}>
                              <LineSection last />
                            </Grid>
                          )}
                      </div>
                    ))}
                  </Body>

                  {deviceWidth > 835 && (
                    <Footer>
                      <Grid container justifyContent="space-between" mb={1}>
                        <Grid item>
                          <TextPrice>ราคาสินค้า</TextPrice>
                        </Grid>

                        <Grid item>
                          <TextPrice price>
                            {convertPrice(
                              sell_list?.product_choice_orders
                                .map((prod) => prod.price * prod.volume)
                                .reduce((sum, number) => {
                                  return sum + number;
                                }, 0),
                            )}
                          </TextPrice>
                          {/* <TextPrice price>{convertPrice(sell_list?.total_price)}</TextPrice> */}
                        </Grid>
                      </Grid>

                      <Grid container justifyContent="space-between" mb={1}>
                        <Grid item>
                          <TextPrice>ค่าติดตั้ง</TextPrice>
                        </Grid>

                        <Grid item>
                          <TextPrice price>
                            {convertPrice(sell_list?.total_installer) ?? "-"}
                          </TextPrice>
                        </Grid>
                      </Grid>

                      <Grid container justifyContent="space-between" mb={1}>
                        <Grid item>
                          <TextPrice>ส่วนลด</TextPrice>
                        </Grid>

                        <Grid item>
                          <TextPrice sumprice>{`-${convertPrice(
                            sell_list?.total_discount,
                          )}`}</TextPrice>
                        </Grid>
                      </Grid>

                      <Grid container justifyContent="space-between" mb={1}>
                        <Grid item>
                          <TextPrice>{`ภาษีมูลค่าเพิ่ม (7%)`}</TextPrice>
                        </Grid>

                        <Grid item>
                          <TextPrice price>
                            {convertPrice(sell_list?.vat)}
                          </TextPrice>
                        </Grid>
                      </Grid>

                      <Grid container justifyContent="space-between" mb={1}>
                        <Grid item>
                          <TextPrice>
                            {`ค่าจัดส่ง + ภาษีมูลค่าเพิ่ม (7%)`}{" "}
                            {checkNotEmpty(
                              sell_list?.delivery_detail_group?.delivery_type,
                            ) &&
                              `(${sell_list?.delivery_detail_group?.delivery_type?.type_th})`}
                          </TextPrice>
                        </Grid>

                        <Grid item>
                          <TextPrice price>
                            {convertPrice(sell_list?.total_delivery)}
                          </TextPrice>
                        </Grid>
                      </Grid>

                      <Grid container justifyContent="space-between" mb={1}>
                        <Grid item>
                          <TextPrice>
                            {`ค่าแพ็คสินค้า + ภาษีมูลค่าเพิ่ม (7%)`}
                          </TextPrice>
                        </Grid>

                        <Grid item>
                          <TextPrice price>
                            {convertPrice(sell_list?.total_packaging)}
                          </TextPrice>
                        </Grid>
                      </Grid>

                      {sell_list?.outstanding_balance ? (
                        <Grid container justifyContent="space-between" mb={1}>
                          <Grid item>
                            <TextPrice>จำนวนเงินทั้งสิ้น</TextPrice>
                          </Grid>

                          <Grid item>
                            <TextPrice price>
                              {convertPrice(
                                sell_list?.total_all +
                                  sell_list?.outstanding_balance,
                              )}
                            </TextPrice>
                          </Grid>
                        </Grid>
                      ) : null}

                      <LineSection />

                      {sell_list?.outstanding_balance ? (
                        <>
                          <Grid container justifyContent="space-between" mb={1}>
                            <Grid item>
                              <TextPrice bold price>
                                ยอดมัดจำ
                              </TextPrice>
                            </Grid>

                            <Grid item>
                              <TextPrice sumprice bold>
                                {convertPrice(sell_list?.total_all)}
                              </TextPrice>
                            </Grid>
                          </Grid>

                          <Grid container justifyContent="space-between" mb={1}>
                            <Grid item>
                              <TextPrice>ยอดค้างชำระ</TextPrice>
                            </Grid>

                            <Grid item>
                              <TextPrice price>
                                {convertPrice(sell_list?.outstanding_balance)}
                              </TextPrice>
                            </Grid>
                          </Grid>
                        </>
                      ) : (
                        <Grid container justifyContent="space-between" mb={1}>
                          <Grid item>
                            <TextPrice bold price>
                              จำนวนเงินทั้งสิ้น
                            </TextPrice>
                          </Grid>

                          <Grid item>
                            <TextPrice sumprice bold>
                              {convertPrice(sell_list?.total_all)}
                            </TextPrice>
                          </Grid>
                        </Grid>
                      )}
                    </Footer>
                  )}
                </Grid>
              </WrapTable>
              {deviceWidth <= 835 && (
                <Footer>
                  <Grid container justifyContent="space-between" mb={1}>
                    <Grid item>
                      <TextPrice>ราคาสินค้า</TextPrice>
                    </Grid>

                    <Grid item>
                      <TextPrice price>
                        {convertPrice(
                          sell_list?.product_choice_orders
                            .map((prod) => prod.price * prod.volume)
                            .reduce((sum, number) => {
                              return sum + number;
                            }, 0),
                        )}
                      </TextPrice>
                      {/* <TextPrice price>{convertPrice(sell_list?.total_price)}</TextPrice> */}
                    </Grid>
                  </Grid>

                  <Grid container justifyContent="space-between" mb={1}>
                    <Grid item>
                      <TextPrice>ค่าติดตั้ง</TextPrice>
                    </Grid>

                    <Grid item>
                      <TextPrice price>
                        {convertPrice(sell_list?.total_installer) ?? "-"}
                      </TextPrice>
                    </Grid>
                  </Grid>

                  <Grid container justifyContent="space-between" mb={1}>
                    <Grid item>
                      <TextPrice>ส่วนลด</TextPrice>
                    </Grid>

                    <Grid item>
                      <TextPrice sumprice>{`-${convertPrice(
                        sell_list?.total_discount,
                      )}`}</TextPrice>
                    </Grid>
                  </Grid>

                  <Grid container justifyContent="space-between" mb={1}>
                    <Grid item>
                      <TextPrice>{`ภาษีมูลค่าเพิ่ม (7%)`}</TextPrice>
                    </Grid>

                    <Grid item>
                      <TextPrice price>
                        {convertPrice(sell_list?.vat)}
                      </TextPrice>
                    </Grid>
                  </Grid>

                  <Grid container justifyContent="space-between" mb={1}>
                    <Grid item>
                      <TextPrice>{`ค่าจัดส่ง (LALAMOVE)`}</TextPrice>
                    </Grid>

                    <Grid item>
                      <TextPrice price>
                        {convertPrice(sell_list?.total_delivery)}
                      </TextPrice>
                    </Grid>
                  </Grid>

                  {sell_list?.outstanding_balance ? (
                    <Grid container justifyContent="space-between" mb={1}>
                      <Grid item>
                        <TextPrice>จำนวนเงินทั้งสิ้น</TextPrice>
                      </Grid>

                      <Grid item>
                        <TextPrice price>
                          {convertPrice(
                            sell_list?.total_all +
                              sell_list?.outstanding_balance,
                          )}
                        </TextPrice>
                      </Grid>
                    </Grid>
                  ) : null}

                  <LineSection />

                  {sell_list?.outstanding_balance ? (
                    <>
                      <Grid container justifyContent="space-between" mb={1}>
                        <Grid item>
                          <TextPrice bold price>
                            ยอดมัดจำ
                          </TextPrice>
                        </Grid>

                        <Grid item>
                          <TextPrice sumprice bold>
                            {convertPrice(sell_list?.total_all)}
                          </TextPrice>
                        </Grid>
                      </Grid>

                      <Grid container justifyContent="space-between" mb={1}>
                        <Grid item>
                          <TextPrice>ยอดค้างชำระ</TextPrice>
                        </Grid>

                        <Grid item>
                          <TextPrice price>
                            {convertPrice(sell_list?.outstanding_balance)}
                          </TextPrice>
                        </Grid>
                      </Grid>
                    </>
                  ) : (
                    <Grid container justifyContent="space-between" mb={1}>
                      <Grid item>
                        <TextPrice bold price>
                          จำนวนเงินทั้งสิ้น
                        </TextPrice>
                      </Grid>

                      <Grid item>
                        <TextPrice sumprice bold>
                          {convertPrice(sell_list?.total_all)}
                        </TextPrice>
                      </Grid>
                    </Grid>
                  )}
                </Footer>
              )}

              {sell_list?.note && (
                <TextField
                  value={sell_list?.note}
                  multiline
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      fontSize: "0.875rem",
                      color: "#6C6C70",
                    },
                    marginTop: "8px",
                  }}
                  inputProps={{ readOnly: true }}
                />
              )}
            </Grid>
          </WrapList>
        ))}

      {deviceWidth <= 835 ? (
        <ButtomSheet>
          <Grid container mt={0} mb={3} justifyContent="space-between">
            <Grid item>
              <TextSumPrice>ยอดรวม</TextSumPrice>
            </Grid>

            <Grid item>
              <TextSumPrice price>
                {convertPrice(order?.total_seller_price)}
              </TextSumPrice>
            </Grid>
          </Grid>

          <Grid container mx="auto" justifyContent="center">
            <ButtonSubmit
              edit
              onClick={() => navigate(`/sale-order/edit/${orderId}`)}
            >
              แก้ไข
            </ButtonSubmit>
            <ButtonSubmit onClick={() => copyClipboard()}>
              คัดลอกลิงก์
            </ButtonSubmit>
          </Grid>
        </ButtomSheet>
      ) : (
        <WrapList>
          <Grid container my={4} justifyContent="space-between">
            <Grid item>
              <TextSumPrice>ยอดรวม</TextSumPrice>
            </Grid>

            <Grid item>
              <TextSumPrice price>
                {convertPrice(order?.total_seller_price)}
              </TextSumPrice>
            </Grid>
          </Grid>

          <Stack direction="row" justifyContent="center" gap={2}>
            <Button
              variant="secondary"
              size="large"
              disabled={
                !checkAllowPermission("sale_features.can_create_saleOrder")
              }
              onClick={() => navigate(`/sale-order/edit/${orderId}`)}
              sx={{ minWidth: 160 }}
            >
              แก้ไข
            </Button>
            <Button
              variant="contained"
              size="large"
              onClick={() => copyClipboard()}
              sx={{ minWidth: 160 }}
            >
              คัดลอกลิงก์
            </Button>
          </Stack>
        </WrapList>
      )}
    </Container>
  );
};

export default SaleOrderDetail;
